import React from 'react'
import PropTypes from 'prop-types'
import { at } from 'lodash'
import { useField } from 'formik'
import { FormControl, Select, MenuItem, FormHelperText } from '@material-ui/core'

interface SelectFieldProps {
    name: string
    data: any
    fullWidth: boolean
    className?: string
    label?: string
}

function SelectField(props: SelectFieldProps) {
    const { label, data, ...rest } = props
    const [field, meta] = useField(props)
    const { value: selectedValue } = field
    const [touched, error] = at(meta, 'touched', 'error')
    const isError = touched && error && true
    function _renderHelperText() {
        if (isError) {
            return <FormHelperText>{error}</FormHelperText>
        }
    }

    return (
        <FormControl {...rest} error={isError} size="small">
            <Select {...field} value={selectedValue ? selectedValue : ''} variant="outlined">
                {data.map((item: any, index: number) => (
                    <MenuItem key={index} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
            {_renderHelperText()}
        </FormControl>
    )
}

SelectField.defaultProps = {
    data: [],
}

SelectField.propTypes = {
    data: PropTypes.array.isRequired,
}

export default SelectField
